import { NatureFrais } from '../shared'

export const HelpFraisPedagogique: { [key in NatureFrais]?: string } = {} as const

export const HelpFraisAnnexe: { [key in NatureFrais]?: string } = {} as const
